export const FORM_QUERY_OPTIONS = {
  structuralSharing: false,
  throwOnError: false,
  refetchOnMount: true,
  staleTime: Infinity,
  gcTime: Infinity,
};
